// removed by extract-text-webpack-plugin
module.exports = {"messageScreen":"MessageDisplay-messageScreen--dVUHA","buttonContainer":"MessageDisplay-buttonContainer--2rceF","timer":"MessageDisplay-timer--cX9GR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MessageDisplay/MessageDisplay.scss
// module id = AL1r
// module chunks = 1